import { Category, Post } from "@forcode/domain";
import { CategoryHeader } from "../../organism/CategoryHeader";
import { PostGridTemplate } from "../PostGridTemplate";

export interface CategoryTemplateProps {
  category: Category;
  posts: Post[];
}

export const CategoryTemplate = ({
  category,
  posts = [],
}: CategoryTemplateProps) => {
  return (
    <>
      <CategoryHeader category={category} />
      <PostGridTemplate posts={posts} />
    </>
  );
};
